import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {StripeCardInput, StripeCardInputStyle} from "../../../../website/authenticated/pages/wallet/components/cards/CardInput";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle, Theme} from "../../../../../stem-core/src/ui/style/Theme";
import {isSmallScreen} from "../../../../UtilsLib";


class CardInputStyle extends StripeCardInputStyle {
    @styleRuleInherit
    inputContainer = {
        background: this.themeProps.WALLET_CREDIT_CARD_BORDER,
        height: 46,
        borderRadius: 4,
        boxShadow: "none !important",
        ">*": {
            height: "100% !important",
            padding: "1.25rem !important",
        }
    };

    @styleRule
    errorMessage = {
        fontSize: 12,
        marginTop: 12,
        color: this.themeProps.WALLET_CARD_ERROR,
    };

    @styleRuleInherit
    input = {
        height: "100% !important",
        padding: "1.25rem !important",
    };

    @styleRule
    error = {
        borderColor: this.themeProps.MERCHANT_ERROR,
        ":hover": {
            borderColor: this.themeProps.MERCHANT_ERROR + " !important",
        },
        " input": {
            color: this.themeProps.MERCHANT_ERROR + " !important",
        },
        " input::placeholder": {
            color: this.themeProps.MERCHANT_ERROR + " !important",
        }
    };
}

@registerStyle(CardInputStyle)
export class CardInput extends StripeCardInput {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            label: "",
            stripeStyle: {
                invalid: {
                    color: Theme.props.WALLET_CARD_ERROR,
                    iconColor: Theme.props.WALLET_CARD_ERROR,
                },
                base: {
                    fontSize: isSmallScreen() ? "16px" : "14px",
                    "::placeholder": {
                        color: Theme.props.WALLET_CREDIT_CARD_INPUT_PLACEHOLDER_COLOR,
                    },
                    color: Theme.props.WALLET_CREDIT_CARD_INPUT_COLOR,
                }
            }
        };
    }
}
